import { useLink, useLogin } from "@refinedev/core";
import useForm from "../../lib/refine/useForm";
import Form from "../../lib/Form";
import { Input, Password } from "../../components/Inputs";
import { Body } from "../../components/Layout/typography";
import { FormContent } from "../../components/Layout/forms";
import {
  YumyButton,
  YumyButtonLinkGrey,
} from "../../components/ButtonsAndLinks";
import {
  IconRegister1,
  IconRegister2,
  IconRegister3,
  IconRegister4,
  IconRegister5,
  IconRegister6,
  IconRegister7,
} from "./icons";

export default function Login() {
  const { mutate: onLogin } = useLogin();
  const { formProps } = useForm({
    resource: "users",
    action: "create",
    successNotification: "Brugerkonto oprettet",
    onMutationSuccess: (_, { email, password }) => {
      onLogin({ email, password });
    },
  });
  const Link = useLink();
  return (
    <>
      <div className="border-l-8 border-yumyGreen flex-1 flex items-center">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 xl:gap-0 gap-8 xl:grid-cols-2">
            <div
              className="w-full h-full relative bg-center bg-no-repeat bg-cover text-white-100 rounded-2xl overflow-hidden px-8 py-16 xl:py-8 xl:px-8"
              style={{ backgroundImage: "url(/images/register-image.png)" }}
            >
              <div className="absolute bg-yumyBlack/90 left-0 right-0 top-0 bottom-0" />
              <div className="absolute bg-yumyBlack h-full left-0 top-0 xl:w-12 2xl:w-20" />
              <div className="flex h-full flex-col gap-6 max-w-lg text-center mx-auto justify-center items-center xl:px-4 relative">
                <h4 className="">Gør din forretning smartere med Yumy.</h4>
                <p className="text-white-56 text-base">
                  Alt-i-én platform til digitale menuer, QR-koder og effektiv
                  bestilling - for kun 399 DKK/måned.
                </p>
                <div className="flex flex-col gap-4 w-full text-left">
                  <div className="flex gap-2">
                    <IconRegister1 />
                    <span>
                      Ubegrænset{" "}
                      <span className="font-bold">Digitale Menuer</span>
                    </span>
                  </div>
                  <div className="flex gap-2">
                    <IconRegister2 />
                    <span>
                      Ubegrænset <span className="font-bold">QR Koder</span>
                    </span>
                  </div>
                  <div className="flex gap-2">
                    <IconRegister3 />
                    <span>
                      Ubegrænset{" "}
                      <span className="font-bold">Produkter og kategorier</span>
                    </span>
                  </div>
                  <div className="flex gap-2">
                    <IconRegister5 />
                    <span>
                      <span className="font-bold">Kitchen Display System</span>
                      (KDS)
                    </span>
                  </div>
                  <div className="flex gap-2">
                    <IconRegister6 />
                    <span>
                      <span className="font-bold">Gratis hjælp</span> til
                      opsætning af din første menu
                    </span>
                  </div>
                  <div className="flex gap-2">
                    <IconRegister7 />
                    <span>
                      <span className="font-bold">Gratis hjælp</span> til design
                      af QR koder
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center items-center px-4">
              <div className="flex flex-col gap-6 max-w-3xl text-left mx-auto justify-center items-start px-4 relative">
                <h1>Opret din Yumy konto</h1>
                <Body md gray48>
                  Optimer din forretning med Yumy.
                </Body>
                <FormContent>
                  <Form
                    {...formProps}
                    initialValues={{
                      first_name: "",
                      last_name: "",
                      email: "",
                      password: "",
                    }}
                  >
                    <Input label="Fornavn" name="first_name" />
                    <Input label="Efternavn" name="last_name" />
                    <Input label="Email" name="email" autoComplete="off" />
                    <Password.PasswordWithRules
                      label="Adgangskode"
                      name="password"
                      autoComplete="new-password"
                    />
                    <Body md gray48>
                      Når du opretter en konto, accepterer du vores{" "}
                      <Link
                        to="terms"
                        className="text-yumyGreen hover:underline hover:text-yumyGreen"
                      >
                        betingelser
                      </Link>{" "}
                      og anerkender vores globale privatlivspolitik.
                    </Body>
                    <YumyButton>Opret konto</YumyButton>
                  </Form>
                  <YumyButtonLinkGrey grey href="/login">
                    Log ind
                  </YumyButtonLinkGrey>
                </FormContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
